import { useState, useEffect } from 'react';

export const useResizing = (containerRef, erdState) => {
  const [isResizingHorizontal, setIsResizingHorizontal] = useState(false);
  const [isResizingVertical, setIsResizingVertical] = useState(false);
  const [resizeStartY, setResizeStartY] = useState(0);
  const [resizeStartHeight, setResizeStartHeight] = useState(0);

  // Mouse handling functions for resizing
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isResizingHorizontal && containerRef.current) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const newWidth = ((e.clientX - containerRect.left) / containerRect.width) * 100;
        const constrainedWidth = Math.max(30, Math.min(80, newWidth));
        erdState.setLeftPanelWidth(constrainedWidth);
      }

      if (isResizingVertical) {
        const deltaY = e.clientY - resizeStartY;
        const newHeight = resizeStartHeight + deltaY;
        const constrainedHeight = Math.max(150, Math.min(600, newHeight));
        erdState.setTextareaHeight(constrainedHeight);
      }
    };

    const handleMouseUp = () => {
      setIsResizingHorizontal(false);
      setIsResizingVertical(false);
    };

    if (isResizingHorizontal || isResizingVertical) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = isResizingHorizontal ? 'col-resize' : 'row-resize';
      document.body.style.userSelect = 'none';
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
  }, [isResizingHorizontal, isResizingVertical, resizeStartY, resizeStartHeight, containerRef, erdState]);

  const handleHorizontalResizeStart = (e) => {
    e.preventDefault();
    setIsResizingHorizontal(true);
  };

  const handleVerticalResizeStart = (e) => {
    e.preventDefault();
    setIsResizingVertical(true);
    setResizeStartY(e.clientY);
    setResizeStartHeight(erdState.textareaHeight);
  };

  return {
    isResizingHorizontal,
    isResizingVertical,
    handleHorizontalResizeStart,
    handleVerticalResizeStart
  };
};